import React from 'react';
import "../styles/footer.css"

import fbicon from "../assets/images/fbicon.png"
import waicon from "../assets/images/waicon.png"
import emailicon from "../assets/images/emailicon.png"
import twittericon from "../assets/images/twittericon.png"

function Footer(props) {
    return (
        <div id="footer">
            <div>
                <p>
                    All rights reserved
                    &copy; Copyright 2020
                </p>
            </div>
            <div id="links">
                {/* <a href="#"> */}
                    {/* <img src={fbicon} />
                </a>

                <a href="#">
                    <img src={twittericon} />
                </a> */}

                {/* <a target="blank" href="https://wa.me/+923454459673?text=Assalamualaikum.">
                    <img src={waicon} />
                </a> */}

                <a href="#">
                    <img src={emailicon} />
                </a>

            </div>
        </div>
    );
}

export default Footer;